import { EPage } from '@/shared/enum/page.enum'
import type { IAccountSidebarOptions } from '@/shared/interfaces/account-sidebar.interface'

export const profileOptionAccountSidebar: IAccountSidebarOptions = {
  title: 'Perfil',
  name: EPage.PROFILE
}

export const logoutOptionAccountSidebar: IAccountSidebarOptions = {
  title: 'Cerrar sesión',
  name: EPage.LANDING
}

export const internetOnDemandOptionAccountSidebar: IAccountSidebarOptions = {
  title: 'Internet bajo demanda',
  name: EPage.INTERNET_ON_DEMAND
}

export const historyOptionAccountSidebar: IAccountSidebarOptions = {
  title: 'Historial de compras',
  name: EPage.HISTORY
}
